import React from 'react';
import {Modal, ModalBody, ModalFooter, ModalHeader} from 'reactstrap';
import "./index.css";
import assets from "../../../../../util/assets";
import CreateVideoContentPage from "../../../../../container/broadcaster/MyLibrary/CreateVideoContentPage";

const EditVideoModal = (props) => {

    return (
        <Modal isOpen={props.isOpen}>
            <ModalHeader className="border-0 " id="upload-file-modal">
                <span className="text-center mb-2 modal-container-title">
                    Edit Content
                </span>
                <img src={assets.broadcast.cross}
                     alt={"cross icon"}
                     onClick={() => {
                         props.toggle();
                     }}/>
            </ModalHeader>
            <ModalBody className="justify-content-center">
                <CreateVideoContentPage
                    history={props.history}
                    toggle={props.toggle}
                    editMode={true}/>
            </ModalBody>
            <ModalFooter className="border-0 justify-content-center">

            </ModalFooter>
        </Modal>
    );
}

export default EditVideoModal;